<template>
    <div class="main tw-flex tw-items-center tw-flex-col tw-justify-center tw-h-fit">
        <div
            class="container tw-relative lg:tw-px-24 !tw-pb-20"
            :class="isAsiInquiry ? 'tw-p-8 tw-bg-cream tw-pt-4 md:tw-pt-0 md:tw-rounded-md' : 'tw-p-3 tw-bg-white md:tw-rounded-lg'"
        >
            <img
                v-if="isAsiInquiry"
                src="/bundles/website/assets/asi-logo-card.svg"
                alt="ASI Reisen"
                class="tw-mx-auto tw-h-20 md:tw-h-28"
            />
            <loading-spinner
                    v-if="pending"
                    :is-overlay="true"
                    :size="50"
            />
            <router-view
                v-if="!pending"
            />
        </div>
    </div>
</template>

<script>
    import {mapActions, mapGetters} from 'vuex';
import LoadingSpinner from './components/baseComponents/LoadingSpinner.vue';

    export default {
  components: { LoadingSpinner },
        data: () => ({
        }),
        computed: {
            ...mapGetters({
                tour: 'tour/route',
                country: 'tour/country',
                inquiry: 'tour/inquiry',
                pending: 'tour/pending',
                isAsiInquiry: 'tour/isAsiInquiry',
            }),
        },
        created () {
            const { tour, country, inquiryType } = this.$options.parent
            if (inquiryType) {
                this.$store.commit('tour/setInquiryType', inquiryType)
            }
            if(tour) {
                this.loadTour(tour)
            } else if(country) {
                this.loadCountry(country)
            }
        },
        watch: {
        },
        methods: {
            ...mapActions({
                loadTour: 'tour/loadTour',
                loadCountry: 'tour/loadCountry',
            }),
        },
    }
</script>


<style scoped>
    .main {
        background-size: cover;
        max-width: 100% !important;
    }

    .container {
        width: 810px;
        max-width: 100%;
        min-height: 560px;
        height: fit-content;
    }
</style>